import type { RouteLocationNormalized } from "vue-router";

// widgets
import { useSearchStudentContextStore } from "@/widgets/search-students/models/store/search-student-context";

/**
 * 학생 관리 페이지로 이동 시 학생 상태를 리셋하는 가드
 * @param to 이동할 라우트
 * @param from 현재 라우트
 */
export const searchedStudentIdGuard = (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
) => {
    const searchStudentContextStore = useSearchStudentContextStore();

    // 검색된 학생의 id 가 있는지 확인 (저장소에 남아있는지 확인)
    const isSearchedStudent =
        searchStudentContextStore.currentSearchedStudentId ||
        searchStudentContextStore.currentSearchedCandidateStudentId ||
        searchStudentContextStore.currentSearchedFormerStudentId;

    // 현 요청된 url 내 student-setting-id 가 포함되어있는지 확인
    const matchedRoutes = to.matched.find((route) => route.name === "student-setting-id");

    if (matchedRoutes && !isSearchedStudent) {
        return "/student-setting";
    } else {
        return true;
    }
};
